// "How DGTG works": the process line in the homepage hero and the sections under it.
// Everything shown comes from here, so changing a step or a promise is an edit to this file only.
// Tone: people, expertise and a decade of campaign data lead; AI is a tool our team uses, never the one in charge.
// Keep every claim true to how DGTG actually works; add figures only when they are confirmed.

// The six stations on the hero's process line, left to right. `glyph` picks the hand-drawn mark in
// HowWeWork.js; `log` is the line shown under the drawing while the station is active.
export const PROCESS_STEPS = [
  {
    id: 'context', glyph: 'signals', title: 'Context',
    log: 'we match your brief to years of campaign results in your category',
    text: 'Every brief starts with what we already know: results from campaigns we have run since 2015 across automotive, finance, ecommerce, gaming, education and electronics, and what your audience is searching and talking about today.',
  },
  {
    id: 'plan', glyph: 'plan', title: 'Plan',
    log: 'our strategists build the plan, and AI checks it against past results',
    text: 'Our strategists build the plan: channels, formats, budget and calendar. AI helps them test it against what similar campaigns delivered before, so the budget goes where it has worked.',
  },
  {
    id: 'create', glyph: 'create', title: 'Create',
    log: 'our writers and designers make it, and AI helps them draft and test versions',
    text: 'Our writers and designers make the articles, ads, video scripts and landing pages. AI helps them draft faster and make more versions to test. People edit and fact-check every piece.',
  },
  {
    id: 'distribute', glyph: 'distribute', title: 'Distribute',
    log: 'we run it across our own sites, publishers, creators and paid media',
    text: 'Reach built over a decade: our own content sites, affiliate publishers, 5,000+ creators, 50M+ email and 100M+ SMS contacts, and media buying on Meta, Google and programmatic.',
  },
  {
    id: 'verify', glyph: 'verify', title: 'Verify',
    log: 'we track every result and filter out fraud before it counts',
    text: 'Tracking and postbacks on every result, fraud and bot filters, lead and sale validation, and a brand-safety check. We know what bad traffic looks like because we have been filtering it for years.',
  },
  {
    id: 'learn', glyph: 'learn', title: 'Learn',
    log: 'we add what this campaign taught us to what we know',
    text: 'Results go back into what we know, so your next campaign starts from what actually worked, not from what we assumed.',
  },
];

// Why brands pick DGTG. `stat` is optional: add a confirmed figure and it shows above the text.
export const FLOW_PROMISES = [
  {
    title: 'A decade of data',
    text: 'Since 2015 we have run campaigns for brands like Mahindra, Samsung, Adidas and Amazon. What those campaigns taught us is where every new plan starts.',
    stat: null,
  },
  {
    title: 'Experts first, AI second',
    text: 'Strategists, writers and media buyers make the decisions. AI does the heavy lifting for them: sorting data, drafting versions and flagging problems early.',
    stat: null,
  },
  {
    title: 'Paid on what it delivers',
    text: 'We agree the result and the price for it before we start: per lead, install, sale or view. Our sales campaigns have averaged 89% approval.',
    stat: null,
  },
];
